import { Header } from './components/Header';
import { SuperVoiceList } from './components/SuperVoiceList';
import { TrackList } from './components/TrackList';

const SuperVoice = () => {
  return (
    <div className="flex h-full">
      <div className="flex-grow">
        <div className="h-full w-full mx-auto grid grid-rows-[auto_minmax(108px,1fr)]">
          <Header />
          <TrackList />
        </div>
      </div>
      <div className="flex-shrink-0 w-[320px] h-full border-l border-jenmusic-border-primary">
        <SuperVoiceList />
      </div>
    </div>
  );
};

export default SuperVoice;
